
import Vue from "vue";
import {
  getOrderImportList,
  updateOrderPaymentStatus,
  getConferenceDetail,
  getPdf,
  submitPaper
} from "@/utils/api";

export default Vue.extend({
  name: "consumer-management",
  data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      limit: 20,
      timer: null,
      multipleSelection: [],
      searchGroup: {
        code: "",
        courseName: "",
        courseIndex: '',
        teacherName: "",
        contractSumAmount: [],
        contractPaymentAmount: [],
        contractResidueAmount: [],
        createdAt: [],
        userName: '',
        paymentStatus: null as any,
        auditStatus: '',
        contactAuthorName: "",
        progress: null as any
      } as any,
      loading: true,
      defaultTime: ["00:00:00", "23:59:59"],
      // Review 弹框相关
      reviewDialogVisible: false,
      reviewForm: {
        paymentMethod: 'Alipay',
        paymentAmount: 0,
        paymentUrl: ''
      } as any,
      currentReviewId: null as any,
      // 证书的数据
      certificateData: {} as any,
      conferenceId: '',
      authors: '',
      code: "",
      title: ''
    };
  },
  created() {
    this.getTableData()
  },
  methods: {
    // 打开支付审核弹框
    openReviewDialog(row: any) {
      this.currentReviewId = row.id;
      this.reviewForm = {
        paymentMethod: row.paymentMethod || 'Alipay',
        paymentAmount: row.orderAmount || 0,
        paymentUrl: row.paymentUrl || ''
      };
      this.conferenceId = row.conferenceId
      this.authors = row.contactAuthorName
      this.code = row.code
      this.title = row.title
      this.reviewDialogVisible = true;
    },
    // 审核通过
    async approvePayment() {
      try {
        await updateOrderPaymentStatus(this.currentReviewId, { paymentStatus: 3 });
        this.$message.success('审核通过');
        this.reviewDialogVisible = false;
        this.getCertificateData()
        // this.getTableData();
      } catch (e) {
        this.$message.error('操作失败');
      }
    },
    // 获取对应生成投递的证书数据
    async getCertificateData() {
      try {
        const res: any = await getConferenceDetail(this.conferenceId);
        this.certificateData = {
          name: res.name || '',
          venue: res.venue || '',
          date: res.date || res.date || '',
          abbreviation: res.abbreviation || '',
          overview: res.overview || '',
          publication: res.publication || '',
          indexation: res.indexation || '',
          stamp: res.stamp || '',
          logo: res.logo || '',
          authors: this.authors,
          code: this.code,
          title: this.title
        } as any;
        // 开始生成证书
        this.$nextTick(() => {
          this.generateCertificate()
        })
      } catch (e) {
        this.$message.error('获取会议信息失败');
      }
    },
    // 生成证书
    async generateCertificate() {
      this.loading = true
      // 获取dom
      const singleDom = (document.getElementById('sawCertificateGenerator') as HTMLFormElement);
      // 获取元素的 HTML 字符串
      const htmlStr = singleDom.outerHTML;
      const obj = {
        htmlStr: htmlStr,
        marginTop: 0,
        marginBottom: 0
      }
      const res = await getPdf(obj);
      const acceptanceLetterUrl = (res as any).url
      await submitPaper(this.currentReviewId, { acceptanceLetterUrl });
      this.getTableData()
      this.loading = false
    },
    // 审核拒绝
    async rejectPayment() {
      try {
        await updateOrderPaymentStatus(this.currentReviewId, { paymentStatus: 4 });
        this.$message.success('审核拒绝');
        this.reviewDialogVisible = false;
        this.getTableData();
      } catch (e) {
        this.$message.error('操作失败');
      }
    },
    copyLink(row: any) {
      const orderId = row?.id;
      // 判断当前环境（正式环境使用固定域名，其他环境使用当前域名）
      let origin = location.hostname
      let baseUrl: any = "";
      if (process.env.NODE_ENV === 'development') {
        baseUrl = window.location.origin
      } else {
        baseUrl = origin.includes('-testserver')
          ? window.location.origin
          : 'http://submission.cambridgeinnovationcenter.org'
      }
      const url = `${baseUrl}/submission?conferenceId=${encodeURIComponent(row.conferenceId)}&orderId=${orderId}&status=student&from=c`;
      this.copyText(url).then(() => {
        this.$message.success('链接已复制');
      }).catch(() => {
        this.$message.error('复制失败，请手动复制');
      });
    },
    goView(row: any, type: any) {
      const orderId = row?.id;
      // 判断当前环境（正式环境使用固定域名，其他环境使用当前域名）
      let origin = location.hostname
      let baseUrl: any = "";
      if (process.env.NODE_ENV === 'development') {
        baseUrl = window.location.origin
      } else {
        baseUrl = origin.includes('-testserver')
          ? window.location.origin
          : 'http://submission.cambridgeinnovationcenter.org'
      }
      window.open(`${baseUrl}/submission?conferenceId=${encodeURIComponent(row.conferenceId)}&orderId=${orderId}&status=teacher&from=c&type=${type}`, '_blank')
    },
    async copyText(text: string) {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return;
      }
      return new Promise<void>((resolve, reject) => {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
          const successful = document.execCommand('copy');
          successful ? resolve() : reject();
        } catch (e) {
          reject(e as any);
        } finally {
          document.body.removeChild(textarea);
        }
      });
    },
    goReview(row: any) {
      const orderId = row.id
      // 判断当前环境（正式环境使用固定域名，其他环境使用当前域名）
      let origin = location.hostname
      let baseUrl: any = "";
      if (process.env.NODE_ENV === 'development') {
        baseUrl = window.location.origin
      } else {
        baseUrl = origin.includes('-testserver')
          ? window.location.origin
          : 'http://submission.cambridgeinnovationcenter.org'
      }
      window.open(`${baseUrl}/submission?conferenceId=${encodeURIComponent(row.conferenceId)}&orderId=${orderId}&status=teacher&from=c`, '_blank')
    },
    // goView(row: any, type: any) {
    //   const orderId = row.id
    //   
    // },
    getTableData() {
      const searchParams: any = JSON.parse(JSON.stringify(this.searchGroup))

      const obj: any = {
        page: this.page,
        limit: this.limit,
        ...searchParams,
        orderType: 2
      };
      // 去掉空值
      for (const key in obj) {
        if (
          obj[key] === "" ||
          obj[key] === null ||
          (Array.isArray(obj[key]) && obj[key].every((v: any) => v === null || v === undefined)) ||
          obj[key].length === 0
        ) {
          delete obj[key];
        }
      }
      getOrderImportList(obj)
        .then((res: any) => {
          this.tableData = res.rows;
          this.total = res.count;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    formatDate(date: any, formatStr = "yyyy-MM-dd HH:mm:ss") {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      // 如果是考试时间或报名截止时间，使用中文年月日格式
      if (formatStr === "yyyy年MM月dd日") {
        return `${year}年${month}月${day}日`;
      }

      return formatStr
        .replace("yyyy", year)
        .replace("MM", month)
        .replace("dd", day)
        .replace("HH", hours)
        .replace("mm", minutes)
        .replace("ss", seconds);
    },
    onPageChange(page: number) {
      this.page = page;
      this.getTableData();
    },
    handleSizeChange(limit: number) {
      this.limit = limit;
      this.getTableData();
    },
    pageChange(page: number) {
      // 金额区间字段名列表
      const rangeFields = ['contractSumAmount', 'contractPaymentAmount', 'contractResidueAmount'];
      for (const field of rangeFields) {
        const val = this.searchGroup[field];
        if (Array.isArray(val)) {

          // 只要有区间输入，必须两个都填且第一个小于第二个，否则不触发
          if ((val[0] !== undefined && val[0] !== null && val[1] !== undefined && val[1] !== null)) {
            if (Number(val[0]) >= Number(val[1])) {
              this.$message.warning('区间输入有误，最小值需小于最大值');
              // console.log('有错', this.searchGroup[field]);
              this.searchGroup[field] = []
              return;
            }
          } else if ((val[0] !== undefined && val[0] !== null) || (val[1] !== undefined && val[1] !== null)) {
            // 只填了一个也不触发
            // console.log('只填了一个');

            return;
          }
        }
      }
      if (this.timer !== null) clearTimeout(this.timer as any);
      (this.timer as any) = setTimeout(() => {
        this.page = page;
        this.getTableData();
      }, 1000);
    },
  },
});
